module.exports = __webpack_public_path__ + "img/serve14.054d1b5e.png";